define('viewmodels/ActionTracker/ConfigureActionTracker',['knockout', 'plugins/router', 'durandal/app', 'services/appsecurity', 'services/navigation', 'durandal/system', 'services/logger', 'services/utils', 'services/AppRoutes', 'viewmodels/GeneralSettings', 'viewmodels/header', 'viewmodels/ActionTracker/ActionItemDashboard', 'viewmodels/ActionTracker/ActionPlanDetails'],
    function (ko, router, app, appsecurity, navigation, system, logger, utils, AppRoutes, ObjGeneralSettings, header, ActionItemDashboardVM, ActionPlanDetailsVM) {

        //var title = 'Landing';
        var vm = {
            activate: function () {
            },
            AutoCreateActionsTabClick: AutoCreateActionsTabClick,
            StandAloneActionsTabClick: StandAloneActionsTabClick,
          //  getControlAreas: getControlAreas,

            ActionItemList: ko.observableArray([]),

            //Auto-Create Action Item variables.
            ActionTitle: ko.observable(),
            ActionDescription: ko.observable(),
            PeriodOfAssessmentList: ko.observableArray([]),
            SelectedPeriodOfAssessment: ko.observableArray([]),
            PeriodOfAssessmentSelected: PeriodOfAssessmentSelected,
            AssessmentTypeList: ko.observableArray([]),
            SelectedAssessmentType: ko.observable(),
            AssessmentTypeSelected: AssessmentTypeSelected,
            ActionOrgLevelList: ko.observableArray([]),
            SelectedActionOrgLevels: ko.observable(),
            ActionOrgLevelsSelected: ActionOrgLevelsSelected,
            ActionSubOrgLevelList: ko.observableArray([]),
            SelectedSubOrgLevel: ko.observable(),
            SubOrgLevelSelected: SubOrgLevelSelected,
            ActionBusinessUnitList: ko.observableArray([]),
            SelectedActionBusinessUnit: ko.observable(),
            ActionControlAreaList: ko.observableArray([]),
            SelectedActionControlArea: ko.observable(),
            ActionResponseList: ko.observableArray([]),
            SelectedActionResponse: ko.observable(),
            FilteredQuestionsList: ko.observableArray([]),
            ViewActionItemDetails: ViewActionItemDetails,
            SelectAllActionItems: SelectAllActionItems,
            SelectAllActionItemsForPlan: SelectAllActionItemsForPlan,
            AllChecked: ko.observable(),
            FetchQuestions: FetchQuestions,
            ClearAutoActionPlanFilter: ClearAutoActionPlanFilter,
            CreateActionItems: CreateActionItems,
            SelectedItems: ko.observableArray([]),
            HideFilterDiv: HideFilterDiv,
            ShowFilterDiv: ShowFilterDiv,
            ActionItemDashboardVM: ActionItemDashboardVM,
            //Stand-Alone Action Item            
            ActionItemTitle: ko.observable(),
            ActionItemDescription: ko.observable(),
            SAIControlArea: ko.observable(),
            StandAloneActionItemList: ko.observableArray([]),
            CreateStandAloneActionItem: CreateStandAloneActionItem,
            SelectedSAIBusinessUnit: ko.observableArray([]),
            StandaloneFlag: ko.observable('N'),

            assessmentTypeList: ko.observableArray([]),
            DropDownValues: ko.observable(),
            ControlAreaSelected: ControlAreaSelected,
            //ActionPlansSelected: ActionPlansSelected,
            ClearStandalonedata: ClearStandalonedata,
            ActionItemDetails: ActionItemDetails,
            BackToAPMDetails: BackToAPMDetails,
            ResponseMoveArrayItem: ko.observableArray([]),
            ActionPlanId: ko.observable(),
            ActionPlanDetailsVM: ActionPlanDetailsVM,
            ActionPlanList: ko.observableArray([]),
            SelectedActionPlans: ko.observable(),
            FetchActionPlanQuestions: FetchActionPlanQuestions,
            LinkActionPlansTabClick: LinkActionPlansTabClick,
            LinkActionItems: LinkActionItems,
            TitlePlanNumber: ko.observable(''),
            ResponseMoveArray: ko.observableArray([]),

            //setTriggerAttach: true,
            attached: attached,
            detached: detached,
            header: header,
            appsecurity: appsecurity,
            AppRoutes: AppRoutes,
            logger: logger,
            utils: utils,
        };

        var AutoActionItemTable = false;
        var SAITable = false;
        var dtable = false;
        // var dtable = false;
        return vm;


        function attached() {
            try {
                vm.StandaloneFlag('N');
                $('#LoadingPeriodOfAssessment').show();
                $('#LoadingAssessmentType').hide();
                $('#LoadingImgDivUser').hide();
                $('#LoadingActionSubOrgLevel').hide();
                $('#LoadingActionBusinessUnit').hide();

                $('#LoadingSAIPeriodOfAssessment').hide();
                $('#LoadingSAIAssessmentType').hide();
                $('#LoadingSAISubOrgLevel').hide();
                $('#LoadingSAIBusinessUnit').hide();

                $('#ActionTabs').tabs();
                $('#ActionTabs').tabs('refresh');
                $("#ddlPeriodOfAssessment").multiselect();
                $("#ddlAssessmentType").multiselect();
                $("#ddlActionOrgLevel").multiselect();
                $("#ddlActionSubOrgLevel").multiselect();
                $("#ddlActionBusinessUnit").multiselect();
                $("#ddlActionControlArea").multiselect();
                $("#ddlActionResponse").multiselect();
                $("#ddlActionPlan").multiselect();
                $("#ddlSAIOrgLevel").multiselect();
                $("#ddlSAISubOrgLevel").multiselect();
                $("#ddlSAIBusinessUnit").multiselect();
                //$("#ActionItemListAccordion").hide();               
                $("#collapseFilterControlsBody").addClass("in");
                $("#collapseActionItemListBody").addClass("in");
                dtable = $("#tblAutoActionItemList").DataTable();
                dtable.destroy();
                $("#tblAutoActionItemList tbody tr").remove();
                dtable = $("#tblAutoActionItemList").DataTable();

                dtable = $("#tblAutoActionItemListforPlan").DataTable();
                dtable.destroy();
                $("#tblAutoActionItemListforPlan tbody tr").remove();
                dtable = $("#tblAutoActionItemListforPlan").DataTable();
                //$('#chkSelectAllActionItems').prop('checked', false);

                //$("#collapseActionItemListHeading").addClass("collapsed");
                //AutoActionItemTable = $('#tblAutoActionItemList').dataTable({ responsive: true });
                // $($('#ActionTabs li').get(0)).trigger('click');
                LoadDropDownvalues();
                // LoadActionItemsList();

                if (vm.ActionPlanDetailsVM.ResponseMoveArrayItem() != undefined && vm.ActionPlanDetailsVM.ResponseMoveArrayItem().length != 0) {
                    vm.ActionPlanId(vm.ActionPlanDetailsVM.ResponseMoveArrayItem().ActionPlanId());
                    vm.TitlePlanNumber(vm.ActionPlanDetailsVM.ResponseMoveArrayItem().ActionItemNumber());
                    //Needed to retain to and fro page navigations
                    vm.appsecurity.ActionPlanId(vm.ActionPlanDetailsVM.ResponseMoveArrayItem().ActionPlanId());
                    vm.appsecurity.ActionPlanLabel(vm.ActionPlanDetailsVM.ResponseMoveArrayItem().ActionItemNumber())
                } else {
                    router.navigate("#ActionTracker/ActionPlanManagement", true);
                    logger.logError('Some error occured, Please contact the Administrator', 'Error', system.getModuleId(vm), true);
                }
                $('#ActionTrackerConfigTabs li').removeClass('active');
                $('#CreatActionPlanTab').addClass('active');
                FillActionPlanDropDown();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: attached() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
            }
            finally {
                //$('#LoadingImgDivUser').hide();
            }
        }

        function detached() {
            try {
                $('#Masterdiv').addClass("pagelevelscroll");
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: detached() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
            }
        }

        function ActionItemDetails() {
            try {

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ActionItemDetails() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
            }
        }
        //-----------------------------Logic starts here------------------------------------
        function LoadDropDownvalues() {
            try {
                return $.ajax({
                    url: "/api/ActionPlan/GetAllDropdownValues",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(function (jsonResult, error) {
                        vm.PeriodOfAssessmentList([]);
                        if (jsonResult != null) {
                            var MappedPeriodOfAssessmentList = $.map(jsonResult.OrgLevelListModelObject, function (result) {
                                return new AssessmentPeriodModel(result);
                            });
                            var filteredIdsList = [];
                            var filteredList = [];
                            for (var i = 0, j = MappedPeriodOfAssessmentList.length; i < j; i++) {
                                if (ko.utils.arrayIndexOf(filteredIdsList, MappedPeriodOfAssessmentList[i].ASSESSMENT_PERIOD_ID()) < 0) {
                                    filteredIdsList.push(MappedPeriodOfAssessmentList[i].ASSESSMENT_PERIOD_ID());
                                    filteredList.push(MappedPeriodOfAssessmentList[i]);
                                }
                            }
                            vm.DropDownValues(jsonResult);
                            vm.PeriodOfAssessmentList(filteredList);
                            vm.SelectedPeriodOfAssessment([]);
                            $('#ddlPeriodOfAssessment').multiselect("refresh");
                            $('#LoadingPeriodOfAssessment').hide();
                        }
                    })
                    .fail(function (jsonResult, error) {
                        $('#LoadingPeriodOfAssessment').hide();
                        logger.logError('An error has occurred while fetching the Filter values. Please contact your Administrator.', 'Error', system.getModuleId(vm), true);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: LoadDropDownvalues() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
            }
        }
        //-----------------------------Logic ends here--------------------------------------

        function ClearStandalonedata() {
            try {
                $("#txtActionItemTitle").val("")
                $("#txtActionItemDescription").val("")
                $("#ddlSAIActionControlArea").val("");
                $("#ddlSAIAssessmentType").val("");
                $("#txtSAIControlArea").val("");
                vm.ActionOrgLevelList([]);
                vm.SelectedActionOrgLevels([]);
                vm.ActionSubOrgLevelList([]);
                vm.SelectedSubOrgLevel([]);
                vm.SelectedActionOrgLevels([]);
                vm.ActionBusinessUnitList([]);
                vm.SelectedSAIBusinessUnit([]);
                vm.ActionOrgLevelList([]);
                $("#ddlSAIOrgLevel").multiselect("refresh");
                $("#ddlSAISubOrgLevel").multiselect("refresh");
                $("#ddlSAIBusinessUnit").multiselect("refresh");
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ClearStandalonedata() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
            }
        }
        function AutoCreateActionsTabClick(data,event) {
            try {
                vm.FilteredQuestionsList([]);
                dtable = $("#tblAutoActionItemList").DataTable();
                dtable.destroy();
                $("#tblAutoActionItemList tbody tr").remove();
                dtable = $("#tblAutoActionItemList").DataTable();
                vm.StandaloneFlag('N');
                vm.SelectedPeriodOfAssessment([]);
                $('#ddlPeriodOfAssessment').multiselect("refresh");
                $('#ActionTrackerConfigTabs li').removeClass('active');
                $('#CreatActionPlanTab').addClass('active');
              
                vm.AssessmentTypeList([]);
                vm.SelectedAssessmentType([]);
                $('#ddlAssessmentType').multiselect("refresh");

                vm.ActionOrgLevelList([]);
                vm.SelectedActionOrgLevels([]);
                $('#ddlActionOrgLevel').multiselect("refresh");

                vm.ActionSubOrgLevelList([]);
                vm.SelectedSubOrgLevel([]);
                $('#ddlActionSubOrgLevel').multiselect("refresh");

                vm.ActionBusinessUnitList([]);
                vm.SelectedActionBusinessUnit([]);
                $('#ddlActionBusinessUnit').multiselect("refresh");

                vm.ActionControlAreaList([]);
                vm.SelectedActionControlArea([]);
                $('#ddlActionControlArea').multiselect("refresh");

                vm.ActionResponseList([]);
                vm.SelectedActionResponse([]);
                $('#ddlActionResponse').multiselect("refresh");

                vm.ActionPlanList([]);
                vm.SelectedActionPlans([]);
                $('#ddlActionPlan').multiselect("refresh");
                //FillActionPlanDropDown();
                vm.FilteredQuestionsList([]);

                //$("#collapseFilterControlsBody").removeClass("in");
                //$("#collapseFilterControlsHeading").removeClass("collapsed");
                //$("#collapseFilterControlsBody").addClass("in");
                //$("#collapseActionItemListBody").removeClass("in");
                //$("#collapseActionItemListHeading").removeClass("collapsed");
                //$("#collapseActionItemListHeading").addClass("collapsed");

                ShowFilterDiv();

                if (AutoActionItemTable != false) {
                    //AutoActionItemTable = $("#tblAutoActionItemList").DataTable({ responsive: true });
                    AutoActionItemTable.destroy();
                    $("#tblAutoActionItemList tbody tr").remove();
                    AutoActionItemTable = false;

                }

                if (vm.DropDownValues().length < 1) {
                    LoadDropDownvalues();
                }

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: AutoCreateActionsTabClick() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
            }
            finally {
            }
        }


        function LinkActionPlansTabClick(data,event) {
            try {
                vm.FilteredQuestionsList([]);
                dtable = $("#tblAutoActionItemListforPlan").DataTable();
                dtable.destroy();
                $("#tblAutoActionItemListforPlan tbody tr").remove();
                dtable = $("#tblAutoActionItemListforPlan").DataTable();
                //$('#chkSelectAllActionItems').prop('checked', false);
                vm.StandaloneFlag('N');

                vm.ActionPlanList([]);
                vm.SelectedActionPlans([]);
                $('#ddlActionPlan').multiselect("refresh");

                vm.FilteredQuestionsList([]);

                ShowFilterDiv();

                if (AutoActionItemTable != false) {
                    AutoActionItemTable.destroy();
                    $("#tblAutoActionItemListforPlan tbody tr").remove();
                    AutoActionItemTable = false;
                }
                $('#ActionTrackerConfigTabs li').removeClass('active');
                $('#LinkActionPlansTabDiv').addClass('active');

                FillActionPlanDropDown();

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: LinkActionPlansTabClick() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
            }
            finally {
            }
        }

        function FillActionPlanDropDown() {
            try {
                return $.ajax({
                    url: "/api/ActionPlan/GetAllActionPlanList",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                .success(ajaxSuccess)
                .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: FillActionPlanDropDown() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
                $('#LoadingImgDivUser').hide();
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null && jsonResult.length > 0) {
                        var MappedPlanList = $.map(jsonResult, function (result) {
                            return new PlanModel(result);
                        });

                        vm.ActionPlanList(MappedPlanList);

                        vm.SelectedActionPlans([]);
                        $('#ddlActionPlan').multiselect("refresh");
                        $('#LoadingImgDivUser').hide();
                    }
                }
                catch (e) {
                    var msg = 'exception' + e + ' | source: ajaxSucess() in FillActionPlanDropDown() in ActionPlanManagement.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in FillActionPlanDropDown() method in ActionPlanManagement.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in FillActionPlanDropDown() method in ActionPlanManagement.js';
                    logger.logMessage(msg);
                }
            }
        }

        function StandAloneActionsTabClick(data,event) {
            try {
                $('#LoadingSAIPeriodOfAssessment').show();
                vm.StandaloneFlag('Y');
                vm.SelectedPeriodOfAssessment([]);

                vm.AssessmentTypeList([]);
                vm.SelectedAssessmentType([]);

                vm.ActionOrgLevelList([]);
                vm.SelectedActionOrgLevels([]);
                $('#ddlSAIOrgLevel').multiselect("refresh");

                vm.ActionSubOrgLevelList([]);
                vm.SelectedSubOrgLevel([]);
                $("#ddlSAISubOrgLevel").multiselect("refresh");

                vm.ActionBusinessUnitList([]);
                vm.SelectedActionBusinessUnit([]);
                $("#ddlSAIBusinessUnit").multiselect("refresh");

                $("#CreateSAIAccordionBody").removeClass("in");
                $("#CreateSAIAccordionHeading").removeClass("collapsed");
                $("#CreateSAIAccordionHeading").addClass("collapsed");

                $('#ActionTrackerConfigTabs li').removeClass('active');
                $('#StandAloneActionsTab').addClass('active');

                if (vm.DropDownValues().length < 1) {
                    LoadDropDownvalues().then(function () {
                        FetchOnlyStandAloneQuestions();
                    });
                }
                else {
                    FetchOnlyStandAloneQuestions();
                    $('#LoadingSAIPeriodOfAssessment').show();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: AutoCreateActionsTabClick() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
            }
            finally {
            }
        }

        function LoadActionItemsList() {
            try {
                return $.ajax({
                    url: "/api/ActionPlan/GetAllActionItems",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
             .success(function (jsonResult, error) {
                 vm.ActionItemList([]);
                 vm.PeriodOfAssessmentList([]);
                 if (jsonResult != null) {

                     var MappedActionItemList = $.map(jsonResult, function (result) {
                         return new ActionItemModel(result);
                     });
                     vm.ActionItemList(MappedActionItemList);

                     var MappedPeriodOfAssessmentList = $.map(jsonResult, function (result) {
                         return new AssessmentPeriodModel(result);
                     });
                     var filteredIdsList = [];
                     var filteredList = [];
                     for (var i = 0, j = MappedPeriodOfAssessmentList.length; i < j; i++) {
                         if (ko.utils.arrayIndexOf(filteredIdsList, MappedPeriodOfAssessmentList[i].ASSESSMENT_PROFILE_APD_UID) < 0) {
                             filteredIdsList.push(MappedPeriodOfAssessmentList[i].ASSESSMENT_PROFILE_APD_UID);
                             filteredList.push(MappedPeriodOfAssessmentList[i]);
                         }
                     }
                     vm.PeriodOfAssessmentList(filteredList);
                 }

                 vm.SelectedPeriodOfAssessment([]);
                 $('#ddlPeriodOfAssessment').multiselect("refresh");
                 $('#LoadingPeriodOfAssessment').hide();
                 $('#LoadingSAIPeriodOfAssessment').hide();
             })
             .fail(function (jsonResult, error) {
                 $('#LoadingPeriodOfAssessment').hide();
                 logger.logError('An error has occurred while fetching the type assessments. Please contact your Administrator.', 'Error', system.getModuleId(vm), true);
             });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: LoadActionItemsList() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
                $('#LoadingPeriodOfAssessment').hide();
            }
            finally {
                //$('#LoadingImgDivUser').hide();
            }
        }

        function LoadStandAloneActionItemList() {
            try {
                vm.StandAloneActionItemList([]);
                var MappedActionItemList = $.map(vm.ActionItemList(), function (result) {
                    if (result.AIM_STANDALONE_FLAG() != undefined && result.AIM_STANDALONE_FLAG() == "Y")
                        return new ActionItem(result);
                });
                if (SAITable == false)
                    SAITable = $("#tblStandAloneActionItemList").DataTable({ responsive: true });
                SAITable.destroy();
                $("#tblStandAloneActionItemList tbody tr").remove();

                vm.StandAloneActionItemList(MappedActionItemList);
                SAITable = $("#tblStandAloneActionItemList").DataTable({ responsive: true });

                $('#LoadingSAIPeriodOfAssessment').hide();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: LoadStandAloneActionItemList() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
                $('#LoadingSAIPeriodOfAssessment').hide();
            }
            finally {
                $('#LoadingImgDivUser').hide();
            }
        }

        function PeriodOfAssessmentSelected() {
            try {
                $('#LoadingAssessmentType').show();
                $('#LoadingSAIAssessmentType').show();
                vm.DropDownValues
                var filteredIdsList = [];
                var filteredList = [];
                for (var i = 0; i < vm.DropDownValues().OrgLevelListModelObject.length; i++) {
                    if ((ko.utils.arrayIndexOf(this.SelectedPeriodOfAssessment(), vm.DropDownValues().OrgLevelListModelObject[i].ProfileId) >= 0)
                        && (ko.utils.arrayIndexOf(filteredIdsList, vm.DropDownValues().OrgLevelListModelObject[i].AssessmentId) < 0)) {
                        filteredIdsList.push(vm.DropDownValues().OrgLevelListModelObject[i].AssessmentId);
                        filteredList.push(vm.DropDownValues().OrgLevelListModelObject[i]);
                    }
                    //if (vm.DropDownValues().OrgLevelListModelObject[i].ProfileId == this.SelectedPeriodOfAssessment())
                    //{

                    //}
                }

                var MappedAssessmentTypeList = $.map(filteredList, function (result) {
                    return new AssessmentTypeModel(result);
                });

                vm.AssessmentTypeList(MappedAssessmentTypeList);

                vm.SelectedAssessmentType([]);
                $('#ddlAssessmentType').multiselect("refresh");
                $('#LoadingAssessmentType').hide();
                $('#LoadingSAIAssessmentType').hide();
                $('#LoadingSAIPeriodOfAssessment').hide();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: PeriodOfAssessmentSelected() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
                $('#LoadingAssessmentType').hide();
                $('#LoadingSAIAssessmentType').hide();
            }
            finally {

            }
        }

        function AssessmentTypeSelected() {
            try {
                $('#LoadingImgDivUser').show();
                FillOrgLevelDropDown();
                FillCompleteSubOrglevelList();
                FillCompleteBuList();
                //FillSubOrgLevelDropDown();
                // FillBUDropDown();
                FillControlAreaDropDown();
                FillResponseDropDown();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: AssessmentTypeSelected() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
            }
            finally {
                $('#LoadingImgDivUser').hide();
            }
        }

        function ControlAreaSelected() {
            try {
                FillResponseDropDown();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ControlAreaSelected() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
            }
        }
        //function getControlAreas() {
        //    try {
        //        var csrfToken = $("input[name='__RequestVerificationToken']").val();
        //        var headers = appsecurity.getSecurityHeaders();
        //        headers.__RequestVerificationToken = csrfToken;
        //        return $.ajax({
        //            url: "/api/ActionPlan/GetAllControlAreaValues",
        //            type: "POST",
        //            headers: headers,
        //            //data: { ProfileId: vm.SelectedPeriodOfAssessment(), BuId: vm.SelectedActionBusinessUnit(), AssessmentId: vm.SelectedAssessmentType(), OrgLevelId: vm.SelectedActionOrgLevels(), SubOrgLevelId: vm.SelectedSubOrgLevel() }
        //            data: { ProfileId: MakePipeDelimited(vm.SelectedPeriodOfAssessment), BuId: MakePipeDelimited(vm.SelectedActionBusinessUnit), AssessmentId: MakePipeDelimited(vm.SelectedAssessmentType), OrgLevelId: MakePipeDelimited(vm.SelectedActionOrgLevels), SubOrgLevelId: MakePipeDelimited(vm.SelectedSubOrgLevel) }
        //        })
        //            .success(function (jsonResult, error) {
        //                var MappedControlAreaList = $.map(jsonResult.ControlOrgLevelListModel, function (result) {
        //                    return new ControlAreaModel(result);
        //                });

        //                vm.ActionControlAreaList(MappedControlAreaList);

        //                vm.SelectedActionControlArea([]);
        //                $('#ddlActionControlArea').multiselect("refresh");


        //            })
        //            .fail(function (jsonResult, error) {
        //                $('#LoadingPeriodOfAssessment').hide();
        //                logger.logError('An error has occurred while fetching the Filter values. Please contact your Administrator.', 'Error', system.getModuleId(vm), true);
        //            });
        //    }
        //    catch (e) {
        //        var msg = 'Exception: ' + e + ' | Source: getControlAreas() method in ConfigureActionTracker.js';
        //        logger.logMessage(msg);
        //    }

        //}
        function FillOrgLevelDropDown() {
            try {
                var filteredIdsList = [];
                var filteredList = [];
                for (var i = 0; i < vm.DropDownValues().OrgLevelListModelObject.length; i++) {
                    if ((ko.utils.arrayIndexOf(vm.SelectedPeriodOfAssessment(), vm.DropDownValues().OrgLevelListModelObject[i].ProfileId) >= 0)
                        && (ko.utils.arrayIndexOf(vm.SelectedAssessmentType(), vm.DropDownValues().OrgLevelListModelObject[i].AssessmentId) >= 0)
                        && (ko.utils.arrayIndexOf(filteredIdsList, vm.DropDownValues().OrgLevelListModelObject[i].OrgLevelId) < 0)) {
                        filteredIdsList.push(vm.DropDownValues().OrgLevelListModelObject[i].OrgLevelId);
                        filteredList.push(vm.DropDownValues().OrgLevelListModelObject[i]);
                    }
                }

                var MappedOrgLevelList = $.map(filteredList, function (result) {
                    return new OrgLevelModel(result);
                });

                vm.ActionOrgLevelList(MappedOrgLevelList);

                vm.SelectedActionOrgLevels([]);
                $('#ddlActionOrgLevel').multiselect("refresh");
                $('#ddlSAIOrgLevel').multiselect("refresh");
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: FillOrgLevelDropDown() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
            }
        }

        function FillCompleteSubOrglevelList() {
            var filteredIdsList = [];
            var filteredList = [];
            for (var i = 0; i < vm.DropDownValues().OrgLevelListModelObject.length; i++) {
                if ((ko.utils.arrayIndexOf(vm.SelectedPeriodOfAssessment(), vm.DropDownValues().OrgLevelListModelObject[i].ProfileId) >= 0)
                    && (ko.utils.arrayIndexOf(vm.SelectedAssessmentType(), vm.DropDownValues().OrgLevelListModelObject[i].AssessmentId) >= 0)
                    && (ko.utils.arrayIndexOf(filteredIdsList, vm.DropDownValues().OrgLevelListModelObject[i].SubOrgLevelId) < 0)) {
                    filteredIdsList.push(vm.DropDownValues().OrgLevelListModelObject[i].SubOrgLevelId);
                    filteredList.push(vm.DropDownValues().OrgLevelListModelObject[i]);
                }
            }

            var MappedSubOrgLevelList = $.map(filteredList, function (result) {
                return new SubOrgLevelModel(result);
            });

            vm.ActionSubOrgLevelList(MappedSubOrgLevelList);

            vm.SelectedSubOrgLevel([]);
            $('#ddlActionSubOrgLevel').multiselect("refresh");
            $("#ddlSAISubOrgLevel").multiselect("refresh");
        }

        function FillSubOrgLevelDropDown() {
            try {
                var filteredIdsList = [];
                var filteredList = [];
                for (var i = 0; i < vm.DropDownValues().OrgLevelListModelObject.length; i++) {
                    if ((ko.utils.arrayIndexOf(vm.SelectedPeriodOfAssessment(), vm.DropDownValues().OrgLevelListModelObject[i].ProfileId) >= 0)
                        && (ko.utils.arrayIndexOf(vm.SelectedAssessmentType(), vm.DropDownValues().OrgLevelListModelObject[i].AssessmentId) >= 0)
                        && (ko.utils.arrayIndexOf(vm.SelectedActionOrgLevels(), vm.DropDownValues().OrgLevelListModelObject[i].OrgLevelId) >= 0)
                        && (ko.utils.arrayIndexOf(filteredIdsList, vm.DropDownValues().OrgLevelListModelObject[i].SubOrgLevelId) < 0)) {
                        filteredIdsList.push(vm.DropDownValues().OrgLevelListModelObject[i].SubOrgLevelId);
                        filteredList.push(vm.DropDownValues().OrgLevelListModelObject[i]);
                    }
                }

                var MappedSubOrgLevelList = $.map(filteredList, function (result) {
                    return new SubOrgLevelModel(result);
                });

                vm.ActionSubOrgLevelList(MappedSubOrgLevelList);

                vm.SelectedSubOrgLevel([]);
                vm.SelectedSubOrgLevel(filteredIdsList);
                $('#ddlActionSubOrgLevel').multiselect("refresh");
                $("#ddlSAISubOrgLevel").multiselect("refresh");
                return true;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: FillSubOrgLevelDropDown() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
            }
        }

        function FillCompleteBuList() {
            var filteredIdsList = [];
            var filteredList = [];
            for (var i = 0; i < vm.DropDownValues().OrgLevelListModelObject.length; i++) {
                if ((ko.utils.arrayIndexOf(vm.SelectedPeriodOfAssessment(), vm.DropDownValues().OrgLevelListModelObject[i].ProfileId) >= 0)
                    && (ko.utils.arrayIndexOf(vm.SelectedAssessmentType(), vm.DropDownValues().OrgLevelListModelObject[i].AssessmentId) >= 0)
                    && (ko.utils.arrayIndexOf(filteredIdsList, vm.DropDownValues().OrgLevelListModelObject[i].BuId) < 0)) {
                    filteredIdsList.push(vm.DropDownValues().OrgLevelListModelObject[i].BuId);
                    filteredList.push(vm.DropDownValues().OrgLevelListModelObject[i]);
                }
            }


            var MappedBUList = $.map(filteredList, function (result) {
                return new BUModel(result);
            });

            vm.ActionBusinessUnitList(MappedBUList);

            vm.SelectedActionBusinessUnit([]);
            $('#ddlActionBusinessUnit').multiselect("refresh");
            $("#ddlSAIBusinessUnit").multiselect("refresh");
        }

        function FillBUDropDown() {
            try {
                var filteredIdsList = [];
                var filteredList = [];
                var filteredName = [];
                for (var i = 0; i < vm.DropDownValues().OrgLevelListModelObject.length; i++) {
                    if ((ko.utils.arrayIndexOf(vm.SelectedPeriodOfAssessment(), vm.DropDownValues().OrgLevelListModelObject[i].ProfileId) >= 0)
                        && (ko.utils.arrayIndexOf(vm.SelectedAssessmentType(), vm.DropDownValues().OrgLevelListModelObject[i].AssessmentId) >= 0)
                        && (ko.utils.arrayIndexOf(vm.SelectedActionOrgLevels(), vm.DropDownValues().OrgLevelListModelObject[i].OrgLevelId) >= 0)
                        && (ko.utils.arrayIndexOf(vm.SelectedSubOrgLevel(), vm.DropDownValues().OrgLevelListModelObject[i].SubOrgLevelId) >= 0)
                        && (ko.utils.arrayIndexOf(filteredIdsList, vm.DropDownValues().OrgLevelListModelObject[i].BuId) < 0)) {
                        filteredIdsList.push(vm.DropDownValues().OrgLevelListModelObject[i].BuId);
                        filteredName.push(vm.DropDownValues().OrgLevelListModelObject[i].BuName)
                        filteredList.push(vm.DropDownValues().OrgLevelListModelObject[i]);
                    }
                }


                var MappedBUList = $.map(filteredList, function (result) {
                    return new BUModel(result);
                });

                vm.ActionBusinessUnitList(MappedBUList);
                vm.SelectedActionBusinessUnit([]);
                vm.SelectedSAIBusinessUnit([])
                vm.SelectedActionBusinessUnit(filteredIdsList);
                vm.SelectedSAIBusinessUnit(filteredName);
                $('#ddlActionBusinessUnit').multiselect("refresh");
                $('#ddlSAIBusinessUnit').multiselect("refresh");
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: FillBUDropDown() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
            }
        }

        function ActionOrgLevelsSelected() {
            try {
                var Status = FillSubOrgLevelDropDown();
                if (Status) {
                    FillBUDropDown();
                }
                //$('#LoadingActionSubOrgLevel').show();
                //$('#LoadingActionBusinessUnit').show();
                //$('#LoadingSAISubOrgLevel').show();
                //$('#LoadingSAIBusinessUnit').show();
                //var filteredIdsList = [];
                //var filteredList = [];
                //var filteredBUIdsList = [];
                //var filteredBUList = [];
                //var filteredBUNames = [];
                //for (var i = 0, j = vm.ActionItemList().length; i < j; i++) {
                //    if ((ko.utils.arrayIndexOf(vm.SelectedPeriodOfAssessment(), vm.ActionItemList()[i].ASSESSMENT_PROFILE_APD_UID()) >= 0)
                //        && (ko.utils.arrayIndexOf(vm.SelectedAssessmentType(), vm.ActionItemList()[i].ASSESSMENT_TYPE_RAT_UID()) >= 0)
                //        && (ko.utils.arrayIndexOf(vm.SelectedActionOrgLevels(), vm.ActionItemList()[i].ORG_EBL_UID()) >= 0)) {
                //        if (ko.utils.arrayIndexOf(filteredIdsList, vm.ActionItemList()[i].SUBORG_DE_UID()) < 0) {
                //            filteredIdsList.push(vm.ActionItemList()[i].SUBORG_DE_UID());
                //            filteredList.push(vm.ActionItemList()[i]);                            
                //        }
                //        else if (ko.utils.arrayIndexOf(filteredBUIdsList, vm.ActionItemList()[i].BU_DE_UID()) < 0) {
                //            filteredBUIdsList.push(vm.ActionItemList()[i].BU_DE_UID());
                //            filteredBUList.push(vm.ActionItemList()[i]);
                //            filteredBUNames.push(vm.ActionItemList()[i].BU_NAME());
                //        }
                //    }
                //}

                //var MappedSubOrgLevelList = $.map(filteredList, function (result) {
                //    return new SubOrgLevelModel(result);
                //});

                //vm.ActionSubOrgLevelList(MappedSubOrgLevelList);

                //vm.SelectedSubOrgLevel(filteredIdsList);
                //$('#ddlActionSubOrgLevel').multiselect("refresh");
                //$("#ddlSAISubOrgLevel").multiselect("refresh");

                //var MappedBUList = $.map(filteredBUList, function (result) {
                //    return new BUModel(result);
                //});

                //vm.ActionBusinessUnitList(MappedBUList);

                //vm.SelectedActionBusinessUnit(filteredBUIdsList);                
                //$('#ddlActionBusinessUnit').multiselect("refresh");

                //vm.SelectedSAIBusinessUnit(filteredBUNames);
                //$("#ddlSAIBusinessUnit").multiselect("refresh");

                //$('#LoadingActionSubOrgLevel').hide();
                //$('#LoadingActionBusinessUnit').hide();
                //$('#LoadingSAISubOrgLevel').hide();
                //$('#LoadingSAIBusinessUnit').hide();

                //-------------------------------------New Logic-------------------

                //$('#LoadingActionSubOrgLevel').show();
                //$('#LoadingActionBusinessUnit').show();
                //$('#LoadingSAISubOrgLevel').show();
                //$('#LoadingSAIBusinessUnit').show();
                //var filteredIdsList = [];
                //var filteredList = [];
                //var filteredBUIdsList = [];
                //var filteredBUList = [];
                //var filteredBUNames = [];
                //for (var i = 0, j = vm.DropDownValues().length; i < j; i++) {
                //    if ((ko.utils.arrayIndexOf(vm.SelectedPeriodOfAssessment(), vm.DropDownValues()[i].ASSESSMENT_PROFILE_APD_UID()) >= 0)
                //        && (ko.utils.arrayIndexOf(vm.SelectedAssessmentType(), vm.DropDownValues()[i].ASSESSMENT_TYPE_RAT_UID()) >= 0)
                //        && (ko.utils.arrayIndexOf(vm.SelectedActionOrgLevels(), vm.DropDownValues()[i].ORG_EBL_UID()) >= 0)) {
                //        if (ko.utils.arrayIndexOf(filteredIdsList, vm.DropDownValues()[i].SUBORG_DE_UID()) < 0) {
                //            filteredIdsList.push(vm.DropDownValues()[i].SUBORG_DE_UID());
                //            filteredList.push(vm.DropDownValues()[i]);                            
                //        }
                //        else if (ko.utils.arrayIndexOf(filteredBUIdsList, vm.DropDownValues()[i].BU_DE_UID()) < 0) {
                //            filteredBUIdsList.push(vm.DropDownValues()[i].BU_DE_UID());
                //            filteredBUList.push(vm.DropDownValues()[i]);
                //            filteredBUNames.push(vm.DropDownValues()[i].BU_NAME());
                //        }
                //    }
                //}

                //var MappedSubOrgLevelList = $.map(filteredList, function (result) {
                //    return new SubOrgLevelModel(result);
                //});

                //vm.ActionSubOrgLevelList(MappedSubOrgLevelList);

                //vm.SelectedSubOrgLevel(filteredIdsList);
                //$('#ddlActionSubOrgLevel').multiselect("refresh");
                //$("#ddlSAISubOrgLevel").multiselect("refresh");

                //var MappedBUList = $.map(filteredBUList, function (result) {
                //    return new BUModel(result);
                //});

                //vm.ActionBusinessUnitList(MappedBUList);

                //vm.SelectedActionBusinessUnit(filteredBUIdsList);                
                //$('#ddlActionBusinessUnit').multiselect("refresh");

                //vm.SelectedSAIBusinessUnit(filteredBUNames);
                //$("#ddlSAIBusinessUnit").multiselect("refresh");

                //$('#LoadingActionSubOrgLevel').hide();
                //$('#LoadingActionBusinessUnit').hide();
                //$('#LoadingSAISubOrgLevel').hide();
                //$('#LoadingSAIBusinessUnit').hide();

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ActionOrgLevelsSelected() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
                $('#LoadingActionSubOrgLevel').hide();
                $('#LoadingActionBusinessUnit').hide();
                $('#LoadingSAISubOrgLevel').hide();
                $('#LoadingSAIBusinessUnit').hide();
            }
        }

        function SubOrgLevelSelected() {
            try {
                FillBUDropDown();

                //$('#LoadingActionBusinessUnit').show();
                //$('#LoadingSAIBusinessUnit').show();
                //var filteredIdsList = [];
                //var filteredList = [];
                //var filteredBUNames = [];
                //for (var i = 0, j = vm.ActionItemList().length; i < j; i++) {
                //    if ((ko.utils.arrayIndexOf(vm.SelectedPeriodOfAssessment(), vm.ActionItemList()[i].ASSESSMENT_PROFILE_APD_UID()) >= 0)
                //        && (ko.utils.arrayIndexOf(vm.SelectedAssessmentType(), vm.ActionItemList()[i].ASSESSMENT_TYPE_RAT_UID()) >= 0)
                //        && (ko.utils.arrayIndexOf(vm.SelectedActionOrgLevels(), vm.ActionItemList()[i].ORG_EBL_UID()) >= 0)
                //        && (ko.utils.arrayIndexOf(vm.SelectedSubOrgLevel(), vm.ActionItemList()[i].SUBORG_DE_UID()) >= 0)
                //            && (ko.utils.arrayIndexOf(filteredIdsList, vm.ActionItemList()[i].BU_DE_UID()) < 0)) {
                //        filteredIdsList.push(vm.ActionItemList()[i].BU_DE_UID());
                //        filteredList.push(vm.ActionItemList()[i]);
                //        filteredBUNames.push(vm.ActionItemList()[i].BU_NAME());
                //    }
                //}

                //var MappedBUList = $.map(filteredList, function (result) {
                //    return new BUModel(result);
                //});

                //vm.ActionBusinessUnitList(MappedBUList);

                //vm.SelectedActionBusinessUnit(filteredIdsList);               
                //$('#ddlActionBusinessUnit').multiselect("refresh");
                //vm.SelectedSAIBusinessUnit(filteredBUNames);
                //$("#ddlSAIBusinessUnit").multiselect("refresh");

                //$('#LoadingActionBusinessUnit').hide();
                //$('#LoadingSAIBusinessUnit').hide();

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SubOrgLevelSelected() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
                $('#LoadingActionBusinessUnit').hide();
                $('#LoadingSAIBusinessUnit').hide();
            }
        }

        function SAIPeriodOfAssessmentSelected() {
            try {

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SAIPeriodOfAssessmentSelected() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
            }
        }

        function SAIOrgLevelSelected() {
            try {

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SAIOrgLevelSelected() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
            }
        }

        function SAISubOrgLevelSelected() {
            try {

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SAIOrgLevelSelected() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
            }
        }



        function FillControlAreaDropDown() {
            try {
                var filteredIdsList = [];
                var filteredList = [];
                for (var i = 0; i < vm.DropDownValues().ControlOrgLevelListModel.length; i++) {
                    if ((ko.utils.arrayIndexOf(vm.SelectedPeriodOfAssessment(), vm.DropDownValues().ControlOrgLevelListModel[i].ProfileId) >= 0)
                        && (ko.utils.arrayIndexOf(vm.SelectedAssessmentType(), vm.DropDownValues().ControlOrgLevelListModel[i].AssessmentId) >= 0)
                        && (ko.utils.arrayIndexOf(filteredIdsList, vm.DropDownValues().ControlOrgLevelListModel[i].ControlAreaId) < 0)) {
                        filteredIdsList.push(vm.DropDownValues().ControlOrgLevelListModel[i].ControlAreaId);
                        filteredList.push(vm.DropDownValues().ControlOrgLevelListModel[i]);
                    }
                }

                var MappedControlAreaList = $.map(filteredList, function (result) {
                    return new ControlAreaModel(result);
                });

                vm.ActionControlAreaList(MappedControlAreaList);

                vm.SelectedActionControlArea([]);
                $('#ddlActionControlArea').multiselect("refresh");
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: FillBUDropDown() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
            }
        }
        function FillResponseDropDown() {
            try {
                var filteredIdsList = [];
                var filteredList = [];
                for (var i = 0; i < vm.DropDownValues().ResponseOrgLevelListModel.length; i++) {
                
                        filteredIdsList.push(vm.DropDownValues().ResponseOrgLevelListModel[i].ResponseValue);
                    filteredList.push(vm.DropDownValues().ResponseOrgLevelListModel[i]);
                    
                }

                var MappedResponseList = $.map(filteredList, function (result) {
                    return new ResponseModel(result);
                });

                vm.ActionResponseList(MappedResponseList);

                vm.SelectedActionResponse([]);
                $('#ddlActionResponse').multiselect("refresh");
                $('#LoadingImgDivUser').hide();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: FillBUDropDown() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
                $('#LoadingImgDivUser').hide();
            }
        }
        //function FillResponseDropDown() {
        //    try {
        //        var csrfToken = $("input[name='__RequestVerificationToken']").val();
        //        var headers = appsecurity.getSecurityHeaders();
        //        headers.__RequestVerificationToken = csrfToken;
        //        return $.ajax({
        //            url: "/api/ActionPlan/GetAllResponseValues",
        //            type: "POST",
        //            headers: headers,
        //            data: { ControlAreas: MakePipeDelimited(vm.SelectedActionControlArea), BuId: MakePipeDelimited(vm.SelectedActionBusinessUnit), ProfileId: MakePipeDelimited(vm.SelectedPeriodOfAssessment), AssessmentId: MakePipeDelimited(vm.SelectedAssessmentType) }
                
        //        })
        //            .success(function (jsonResult, error) {
        //                var MappedResponseList = $.map(jsonResult.ControlOrgLevelListModel, function (result) {
        //                    return new ResponseModel(result);
        //                });

        //                vm.ActionResponseList(MappedResponseList);

        //                vm.SelectedActionResponse([]);
        //                $('#ddlActionResponse').multiselect("refresh");
        //                $('#LoadingImgDivUser').hide();
        //            })
        //            .fail(function (jsonResult, error) {
        //                $('#LoadingPeriodOfAssessment').hide();
        //                logger.logError('An error has occurred while fetching the Filter values. Please contact your Administrator.', 'Error', system.getModuleId(vm), true);
        //            });

              
        //    }
        //    catch (e) {
        //        var msg = 'Exception: ' + e + ' | Source: FillBUDropDown() method in ConfigureActionTracker.js';
        //        logger.logMessage(msg);
        //        $('#LoadingImgDivUser').hide();
        //    }
        //}
        function MakePipeDelimited(Response) {
            try {
                if (vm.StandaloneFlag() == 'Y' || Response().length == undefined || Response().length == 0) {
                    return null;
                }
                else {
                    for (var i = 0; i < Response().length; i++) {
                        if (i == 0)
                            profileId = Response()[i];
                        else
                            profileId = profileId + "|" + Response()[i];
                    }
                }


                return profileId;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: MakePipeDelimited() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
            }
        }
        function checkforemptylist() {
            try {
                if (vm.SelectedActionBusinessUnit().length == 0) {
                    var filteredIdsList = [];
                    var filteredList = [];
                    for (var i = 0; i < vm.DropDownValues().OrgLevelListModelObject.length; i++) {
                        if ((ko.utils.arrayIndexOf(vm.SelectedPeriodOfAssessment(), vm.DropDownValues().OrgLevelListModelObject[i].ProfileId) >= 0)
                            && (ko.utils.arrayIndexOf(vm.SelectedAssessmentType(), vm.DropDownValues().OrgLevelListModelObject[i].AssessmentId) >= 0)
                            && (ko.utils.arrayIndexOf(filteredIdsList, vm.DropDownValues().OrgLevelListModelObject[i].BuId) < 0)) {
                            filteredIdsList.push(vm.DropDownValues().OrgLevelListModelObject[i].BuId);
                            filteredList.push(vm.DropDownValues().OrgLevelListModelObject[i]);
                        }
                    }

                    vm.SelectedActionBusinessUnit([]);
                    vm.SelectedActionBusinessUnit(filteredIdsList);
                    $('#ddlActionBusinessUnit').multiselect("refresh");
                    $("#ddlSAIBusinessUnit").multiselect("refresh");
                }
                if (vm.SelectedActionControlArea().length == 0) {


                    var filteredIdsList = [];
                    var filteredList = [];
                    for (var i = 0; i < vm.DropDownValues().ControlOrgLevelListModel.length; i++) {
                        if ((ko.utils.arrayIndexOf(vm.SelectedPeriodOfAssessment(), vm.DropDownValues().ControlOrgLevelListModel[i].ProfileId) >= 0)
                            && (ko.utils.arrayIndexOf(vm.SelectedAssessmentType(), vm.DropDownValues().ControlOrgLevelListModel[i].AssessmentId) >= 0)
                            && (ko.utils.arrayIndexOf(filteredIdsList, vm.DropDownValues().ControlOrgLevelListModel[i].ControlAreaId) < 0)) {
                            filteredIdsList.push(vm.DropDownValues().ControlOrgLevelListModel[i].ControlAreaId);
                            filteredList.push(vm.DropDownValues().ControlOrgLevelListModel[i]);
                        }
                    }

                    vm.SelectedActionControlArea([]);
                    vm.SelectedActionControlArea(filteredIdsList);
                    $('#ddlActionControlArea').multiselect("refresh");
                }
                if (vm.SelectedActionResponse().length == 0) {
                    var filteredIdsList = [];
                    var filteredList = [];
                    for (var i = 0; i < vm.DropDownValues().ControlOrgLevelListModel.length; i++) {
                        if ((ko.utils.arrayIndexOf(vm.SelectedPeriodOfAssessment(), vm.DropDownValues().ControlOrgLevelListModel[i].ProfileId) >= 0)
                            && (ko.utils.arrayIndexOf(vm.SelectedAssessmentType(), vm.DropDownValues().ControlOrgLevelListModel[i].AssessmentId) >= 0)
                            && (ko.utils.arrayIndexOf(filteredIdsList, vm.DropDownValues().ControlOrgLevelListModel[i].ResponseValue) < 0)) {
                            filteredIdsList.push(vm.DropDownValues().ControlOrgLevelListModel[i].ResponseValue);
                            filteredList.push(vm.DropDownValues().ControlOrgLevelListModel[i]);
                        }
                    }
                    vm.SelectedActionResponse([])
                    vm.SelectedActionResponse(filteredIdsList);
                    $('#ddlActionResponse').multiselect("refresh");
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: checkforemptylist() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
            }
        }
        function FetchQuestions() {
            try {
               
                $('#LoadingImgDivUser').show();
                checkforemptylist();
                if (ValidateActionPlanFilter()) {
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    return $.ajax({
                        url: "/api/ActionPlan/GetAllActionItemsOnSelection",
                        type: "POST",
                        headers: headers,
                        data: { AssessmentProfile: MakePipeDelimited(vm.SelectedPeriodOfAssessment), BuId: MakePipeDelimited(vm.SelectedActionBusinessUnit), Assessment_Type: MakePipeDelimited(vm.SelectedAssessmentType), ControlArea: MakePipeDelimited(vm.SelectedActionControlArea), Response: MakePipeDelimited(vm.SelectedActionResponse), StandaloneFlag: vm.StandaloneFlag() }
                    })
                        .success(function (jsonResult, error) {


                            $('#LoadingImgDivUser').hide();
                            if (vm.StandaloneFlag() == 'N') {
                                vm.FilteredQuestionsList([]);
                                var MappedList = $.map(jsonResult, function (item) {
                                    return new ActionItemModel(item);
                                })
                                
                                $('#tblAutoActionItemList').DataTable().destroy();
                                $("#tblAutoActionItemList tbody tr").remove();

                                vm.FilteredQuestionsList(MappedList);
                                $("#tblAutoActionItemList").DataTable({
                                    stateSave: true,
                                    bAutoWidth: false, // Disable the auto width calculation 
                                    bSortClasses: false,
                                    bpaginate: "full_numbers",
                                    iDisplayLength: 10,
                                    bLengthChange: true

                                });


                                $("#LoadingImgDivUser").hide();
                                $("#FetchQuestionsIcon").removeClass("fa-spin");
                                $("#collapseFilterControlsBody").removeClass('show');
                                $("#collapseActionItemListBody").addClass('show');


                          //      HideFilterDiv();
                            }
                            else if (vm.StandaloneFlag() == 'Y') {
                                vm.StandAloneActionItemList([]);
                                var MappedList = $.map(jsonResult, function (item) {
                                    return new ActionItemModel(item);
                                })
                                if (SAITable == false)
                                    SAITable = $("#tblStandAloneActionItemList").DataTable({ responsive: true });
                                var p = SAITable.page.info().page;
                                SAITable.destroy();
                                $("#tblStandAloneActionItemList tbody tr").remove();

                                vm.StandAloneActionItemList(MappedList);
                                SAITable = $("#tblStandAloneActionItemList").DataTable({ responsive: true });
                                SAITable.page(p).draw(false);
                                $('#LoadingSAIPeriodOfAssessment').hide();
                            }
                        })
                        .fail(function (jsonResult, error) {
                            $('#LoadingPeriodOfAssessment').hide();
                            logger.logError('An error has occurred while fetching the Filter values. Please contact your Administrator.', 'Error', system.getModuleId(vm), true);
                        });
                }
                $("#LoadingImgDivUser").hide();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: FetchQuestions() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
                $("#LoadingImgDivUser").hide();
            }
        }

        //function ActionPlansSelected() {
        //    try {
        //        $("#btnFetchPlanQuestions").show();
        //        $("#btnFetchQuestions").hide();
        //    }
        //    catch (e) {
        //        var msg = 'Exception: ' + e + ' | Source: ActionPlansSelected() method in ConfigureActionTracker.js';
        //        logger.logMessage(msg);
        //    }
        //}

        function FetchActionPlanQuestions() {
            try {
                $('#LoadingImgDivUser').show();
                checkforemptylist();
                if (ValidateActionPlanListFilter()) {
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    return $.ajax({
                        url: "/api/ActionPlan/GetAllActionItemsOnPlanSelection",
                        type: "GET",
                        headers: headers,
                        data: { ActionPlans: MakePipeDelimited(vm.SelectedActionPlans) }
                    })
                        .success(function (jsonResult, error) {
                            $('#LoadingImgDivUser').hide();
                            if (vm.StandaloneFlag() == 'N') {
                                vm.FilteredQuestionsList([]);
                                var MappedList = $.map(jsonResult, function (item) {
                                    return new ActionItemModel(item);
                                })


                                $('#tblAutoActionItemListforPlan').DataTable().destroy();
                                $("#tblAutoActionItemListforPlan tbody tr").remove();
                                vm.FilteredQuestionsList(MappedList);
                                $("#tblAutoActionItemListforPlan").DataTable();

                                //$('#chkSelectAllActionItems').prop('checked', false);
                                $("#LoadingImgDivUser").hide();
                                $("#FetchQuestionsIcon").removeClass("fa-spin");
                                HideFilterDiv();
                            }
                        })
                        .fail(function (jsonResult, error) {
                            $('#LoadingPeriodOfAssessment').hide();
                            logger.logError('An error has occurred while fetching the Filter values. Please contact your Administrator.', 'Error', system.getModuleId(vm), true);
                        });
                }
                $("#LoadingImgDivUser").hide();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: FetchActionPlanQuestions() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
                $("#LoadingImgDivUser").hide();
            }
        }

        function FetchOnlyStandAloneQuestions() {
            try {
                $('#LoadingImgDivUser').show();
                checkforemptylist();
                
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    return $.ajax({
                        url: "/api/ActionPlan/GetAllActionItemsOnPlanSelection",
                        type: "GET",
                        headers: headers,
                        data: { ActionPlans: vm.ActionPlanId() }
                    })
                        .success(function (jsonResult, error) {
                            $('#LoadingImgDivUser').hide();
                            if (vm.StandaloneFlag() == 'Y') {
                                vm.StandAloneActionItemList([]);
                                var MappedList = $.map(jsonResult, function (item) {
                                    if (item.AIM_STANDALONE_FLAG == 'Y') {
                                        return new ActionItemModel(item);
                                    }
                                })
                                if (SAITable == false)
                                    SAITable = $("#tblStandAloneActionItemList").DataTable({ responsive: true });
                                var p = SAITable.page.info().page;
                                SAITable.destroy();
                                $("#tblStandAloneActionItemList tbody tr").remove();

                                vm.StandAloneActionItemList(MappedList);
                                SAITable = $("#tblStandAloneActionItemList").DataTable({ responsive: true });
                                SAITable.page(p).draw(false);
                                $('#LoadingSAIPeriodOfAssessment').hide();
                            }
                        })
                        .fail(function (jsonResult, error) {
                            $('#LoadingPeriodOfAssessment').hide();
                            logger.logError('An error has occurred while fetching the Filter values. Please contact your Administrator.', 'Error', system.getModuleId(vm), true);
                        });
                
                $("#LoadingImgDivUser").hide();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: FetchActionPlanQuestions() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
                $("#LoadingImgDivUser").hide();
            }
        }

        function ValidateActionPlanFilter() {
            try {
                if (vm.StandaloneFlag() == 'Y') {
                    return true;
                }
                else {
                    var Validated = false;
                    $('#AutoActionPlanError').text("");
                    $('#AutoActionPlanError').show();
                    if (vm.SelectedPeriodOfAssessment == 'undefined' || vm.SelectedPeriodOfAssessment().length < 1) {
                        $('#AutoActionPlanError').text("Select atleast one Period of Assessment.");
                    }
                    else if (vm.SelectedAssessmentType == 'undefined' || vm.SelectedAssessmentType().length < 1) {
                        $('#AutoActionPlanError').text("Select atleast one Assessment Type.");
                    }
                    else {
                        Validated = true;
                        $('#AutoActionPlanError').text("");
                    }
                    return Validated;
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ValidateActionPlanFilter() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
            }
        }

        function ValidateActionPlanListFilter() {
            try {
                if (vm.StandaloneFlag() == 'Y') {
                    return true;
                }
                else {
                    var Validated = false;
                    $('#AutoActionPlanError').text("");
                    $('#AutoActionPlanError').show();
                    if (vm.SelectedActionPlans == 'undefined' || vm.SelectedActionPlans().length < 1) {
                        $('#AutoActionPlanError').text("Select atleast one action plan.");
                    }
                    else {
                        Validated = true;
                        $('#AutoActionPlanError').text("");
                    }
                    return Validated;
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ValidateActionPlanFilter() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
            }
        }

        function ValidateStandAloneActionItem() {
            try {
                var Validated = false;
                $('#StandAloneActionItemError').text("");
                $('#StandAloneActionItemError').show();
                if (vm.ActionItemTitle() == undefined || vm.ActionItemTitle() == "") {
                    $('#StandAloneActionItemError').text("Please provide a title to the action items being created.");
                }
                else if (vm.SelectedPeriodOfAssessment == 'undefined' || vm.SelectedPeriodOfAssessment().length < 1) {
                    $('#StandAloneActionItemError').text("Select atleast one Period of Assessment.");
                }
                else if (vm.SelectedAssessmentType == 'undefined' || vm.SelectedAssessmentType().length < 1) {
                    $('#StandAloneActionItemError').text("Select atleast one Assessment Type.");
                }
                else {
                    Validated = true;
                    $('#StandAloneActionItemError').text("");
                }
                return Validated;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ValidateStandAloneActionItem() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
            }
        }

        function ClearAutoActionPlanFilter() {
            try {
                $('#AutoActionPlanError').text("");
                vm.SelectedPeriodOfAssessment([]);
                $('#ddlPeriodOfAssessment').multiselect("refresh");
                vm.SelectedAssessmentType([]);
                $('#ddlAssessmentType').multiselect("refresh");
                vm.SelectedActionOrgLevels([]);
                $('#ddlActionOrgLevel').multiselect("refresh");
                vm.SelectedSubOrgLevel([]);
                $('#ddlActionSubOrgLevel').multiselect("refresh");
                vm.SelectedActionBusinessUnit([]);
                $('#ddlActionBusinessUnit').multiselect("refresh");
                vm.SelectedActionControlArea([]);
                $('#ddlActionControlArea').multiselect("refresh");
                vm.SelectedActionResponse([]);
                $('#ddlActionResponse').multiselect("refresh");
                vm.SelectedActionPlans([]);
                $('#ddlActionPlan').multiselect("refresh");

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ClearAutoActionPlanFilter() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
            }
        }

        function ViewActionItemDetails(data, event) {
            try {
                var AIMUID;
                if (data.AIM_UID.length == undefined) {
                    AIMUID = data.AIM_UID;
                }
                else {
                    AIMUID = data.AIM_UID();
                }
                vm.appsecurity.ActionFlagType("Create");
                vm.ActionItemDashboardVM.ResponseMoveArray(new ResponseMoveModel({ ActionItemId: AIMUID, ActionItemNumber: data.AIM_GENERIC_ID(), RoleName: '', ActionItemStatus: '', RoleId: '', CompletedFlag: true, IsComposeFlag: ko.observable(1) }));
                router.navigate("#ActionTracker/ActionItemDetails", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ViewActionItemDetails() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
            }
        }

        function SelectAllActionItems(data, event) {
            try {
                //var status = vm.AllChecked();
                ko.utils.arrayForEach(data.FilteredQuestionsList(), function (listItem) {
                    listItem.IS_SELECTED(event.currentTarget.checked);
                });
                //vm.AllChecked(!status);
                //if (event.currentTarget.checked) {
                //    for (var i = 0; i < ActionItemDashboardVM.ActionItemModelList().length; i++) {
                //        ActionItemDashboardVM.ActionItemModelList()[i].isChecked(event.currentTarget.checked);
                //    }
                //}
                //else {
                //    for (var i = 0; i < ActionItemDashboardVM.ActionItemModelList().length; i++) {
                //        ActionItemDashboardVM.ActionItemModelList()[i].isChecked(event.currentTarget.checked);
                //    }
                //}
                //var rows = $("#tblactiondetails").dataTable().fnGetNodes();
                //var cells = [];
                //for (var i = 0; i < rows.length; i++) {
                //    if (event.currentTarget.checked == true)
                //        $(rows[i]).find("td:eq(0)").find('input').prop("checked", true);
                //    else
                //        $(rows[i]).find("td:eq(0)").find('input').prop("checked", false);
                //}
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SelectAllActionItems() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
            }
        }

        function SelectAllActionItemsForPlan(data, event) {
            try {
                ko.utils.arrayForEach(data.FilteredQuestionsList(), function (listItem) {
                    listItem.IS_SELECTED(event.currentTarget.checked);
                });
                //var allPages = $("#tblAutoActionItemListforPlan").dataTable().fnGetNodes();
                ////$('body').on('click', '#chkSelectAllActionItemsforPlan', function () {
                //if ($(this).hasClass('allChecked')) {
                //    $('input[type="checkbox"]', allPages).prop('checked', false);
                //} else {
                //    $('input[type="checkbox"]', allPages).prop('checked', true);
                //}
                //    $(this).toggleClass('allChecked');
                ////})
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SelectAllActionItems() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
            }
        }

        function CreateActionItems(data, event) {
            try {

                $("#LoadingImgDivUser").show();
                data.SelectedItems([]);

                if (data.ActionTitle() == undefined || data.ActionTitle() == "") {
                    logger.logError('Please provide a title to the action items being created.', 'Error', system.getModuleId(vm), true);
                    //alert("Please provide a title to the action items being created.");
                    $('#LoadingImgDivUser').hide();
                }
                else {
                    ko.utils.arrayForEach(data.FilteredQuestionsList(), function (listItem) {
                        if (listItem.IS_SELECTED()) {
                            
                            data.SelectedItems.push(listItem);
                        }
                    });
                    if (data.SelectedItems().length < 1) {
                        alert("No Action items are selected. Please select atleast one Action Item.");
                        $('#LoadingImgDivUser').hide();
                        vm.ActionTitle("");
                        vm.ActionDescription("");
                    }
                    else {
                        if (data.ActionDescription() == undefined) {
                            data.ActionDescription("");
                        }
                        var csrfToken = $("input[name='__RequestVerificationToken']").val();
                        var headers = appsecurity.getSecurityHeaders();
                        headers.__RequestVerificationToken = csrfToken;
                        $.ajax({
                            url: "/api/ActionPlan/CreateActionItems?title=" + data.ActionTitle() + "&description=" + data.ActionDescription() + "&isStandAloneActionItem=N" + "&ActionplanId=" + vm.ActionPlanId(),
                            type: "POST",
                            headers: headers,
                            contentType: 'application/json',
                            dataType: 'json',
                            data: JSON.stringify($.map(data.SelectedItems(), function (item) {
                                return new ActionItem(item);
                            }))
                        })
                        .success(function (jsonResult, success) {
                            if (jsonResult == null) {
                                logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(vm), true);
                            }
                            else if (jsonResult < 1) {
                                logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(vm), true);
                            }
                            else {
                                logger.logSuccess('Action Item/s created successfully.', 'Success', system.getModuleId(vm), true);



                            }
                            //LoadActionItemsList().then(function () {
                            //    FetchQuestions();
                            //});
                            //$("#collapseFilterControlsBody").addClass("in");
                            //$("#collapseFilterControlsHeading").removeClass("collapsed");
                            //$("#collapseActionItemListBody").removeClass("in");
                            //$("#collapseActionItemListHeading").addClass("collapsed");
                            var p = dtable.page.info().page;

                            $('#tblAutoActionItemList').DataTable().destroy();
                            $("#tblAutoActionItemList tbody tr").remove();
                           

                            vm.FilteredQuestionsList([]);
                            dtable = $("#tblAutoActionItemList").DataTable({ responsive: true });

                            dtable.page(p).draw(false);
                            vm.ActionTitle("");
                            vm.ActionDescription("");

                            FetchQuestions().then(function () {
                                ShowFilterDiv();
                                //dtable.page(p).draw(false);
                            })


                            $("#LoadingImgDivUser").hide();
                        })
                        .fail(function (fail, error) {
                            logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(vm), true);
                            $("#LoadingImgDivUser").hide();
                        });
                    }
                }
               
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: CreateActionItems() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
                $('#LoadingImgDivUser').hide();
            }
        }

        function LinkActionItems(data, event) {
            try {

                $("#LoadingImgDivUser").show();
                data.SelectedItems([]);

                ko.utils.arrayForEach(data.FilteredQuestionsList(), function (listItem) {
                    if (listItem.IS_SELECTED()) {
                        data.SelectedItems.push(listItem);
                    }
                });
                if (data.SelectedItems().length < 1) {
                    alert("No Action Item is selected. Please select atleast one Action Item.");
                    $("#LoadingImgDivUser").hide();
                }
                else {
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    $.ajax({
                        url: "/api/ActionPlan/CreateActionItems?title=" + "" + "&description=" + "" + "&isStandAloneActionItem=N" + "&ActionplanId=" + vm.ActionPlanId(),
                        type: "POST",
                        headers: headers,
                        contentType: 'application/json',
                        dataType: 'json',
                        data: JSON.stringify($.map(data.SelectedItems(), function (item) {
                            return new ActionItem(item);
                        }))
                    })
                    .success(function (jsonResult, success) {
                        if (jsonResult == null) {
                            logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(vm), true);
                        }
                        else if (jsonResult < 1) {
                            logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(vm), true);
                        }
                        else {
                            logger.logSuccess('Action Plans linked successfully.', 'Success', system.getModuleId(vm), true);
                        }
                        FetchActionPlanQuestions();

                        $("#LoadingImgDivUser").hide();
                    })
                    .fail(function (fail, error) {
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(vm), true);
                        $("#LoadingImgDivUser").hide();
                    });
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: LinkActionItems() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
                $('#LoadingImgDivUser').hide();
            }
        }

        function CreateStandAloneActionItem(data, event) {
            try {
                
                if (ValidateStandAloneActionItem()) {
                    if (data.ActionItemDescription() == undefined) {
                        data.ActionItemDescription("");
                    }

                    var PeriodID = parseInt(data.SelectedPeriodOfAssessment().toString());
                    var AssessmentID = parseInt(data.SelectedAssessmentType().toString());
                    //var clientID=vm.ActionItemList().find(function(e){return e.ASSESSMENT_PROFILE_APD_UID==PeriodID});

                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    $.ajax({
                        url: "/api/ActionPlan/CreateActionItems?title=" + data.ActionItemTitle() + "&description=" + data.ActionItemDescription() + "&isStandAloneActionItem=Y" + "&ActionplanId=" + vm.ActionPlanId(),
                        type: "POST",
                        headers: headers,
                        contentType: 'application/json',
                        dataType: 'json',
                        data: JSON.stringify([{ ASSESSMENT_PROFILE_APD_UID: PeriodID, ASSESSMENT_TYPE_RAT_UID: AssessmentID, BU_NAME: data.SelectedSAIBusinessUnit().toString(), CONTROL_AREA_NAME: data.SAIControlArea() }])
                    })
                    .success(function (jsonResult, success) {
                        if (jsonResult == null) {
                            logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(vm), true);
                        }
                        else if (jsonResult < 1) {
                            logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(vm), true);
                        }
                        else {
                            logger.logSuccess('Action Item/s created successfully.', 'Success', system.getModuleId(vm), true);
                            //LoadActionItemsList().then(function () {
                            //    LoadStandAloneActionItemList();
                            //})
                            ClearStandalonedata();
                            FetchOnlyStandAloneQuestions();

                        } $('#LoadingImgDivUser').hide();
                        $("#CreateSAIAccordionBody").removeClass("in");
                        $("#CreateSAIAccordionHeading").removeClass("collapsed");
                        $("#CreateSAIAccordionHeading").addClass("collapsed");
                    })
                        .fail(function (fail, error) {
                            logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(vm), true);
                            $('#LoadingImgDivUser').hide();
                        });
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: CreateStandAloneActionItem() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
                $('#LoadingImgDivUser').hide();
            }
        }

        function HideFilterDiv() {
            $("#FilterControlsAccordion").hide();

            //$("#FilterControlsAccordion").removeClass("col-lg-4");
            //$("#FilterControlsAccordion").removeClass("col-md-4");
            //$("#FilterControlsAccordion").removeClass("col-sm-4");
            //$("#FilterControlsAccordion").removeClass("col-xs-4");

            $("#btnShowFilterDiv").show();

            //$("#ActionItemListAccordionDiv").removeClass("col-lg-8");
            //$("#ActionItemListAccordionDiv").addClass("col-lg-12");
            //$("#ActionItemListAccordionDiv").removeClass("col-md-8");
            //$("#ActionItemListAccordionDiv").addClass("col-md-12");
            //$("#ActionItemListAccordionDiv").removeClass("col-sm-8");
            //$("#ActionItemListAccordionDiv").addClass("col-sm-12");
            //$("#ActionItemListAccordionDiv").removeClass("col-xs-8");
            //$("#ActionItemListAccordionDiv").addClass("col-xs-12");
        }

        function ShowFilterDiv() {
            $("#FilterControlsAccordion").show();

            $("#btnShowFilterDiv").hide();
            //$("#FilterControlsAccordion").removeClass("col-lg-1");
            $("#FilterControlsAccordion").addClass("col-lg-4");
            $("#FilterControlsAccordion").addClass("col-md-4");
            $("#FilterControlsAccordion").addClass("col-sm-4");
            $("#FilterControlsAccordion").addClass("col-xs-4");

            $("#ActionItemListAccordionDiv").removeClass("col-lg-12");
            $("#ActionItemListAccordionDiv").addClass("col-lg-8");
            $("#ActionItemListAccordionDiv").removeClass("col-md-12");
            $("#ActionItemListAccordionDiv").addClass("col-md-8");
            $("#ActionItemListAccordionDiv").removeClass("col-sm-12");
            $("#ActionItemListAccordionDiv").addClass("col-sm-8");
            $("#ActionItemListAccordionDiv").removeClass("col-xs-12");
            $("#ActionItemListAccordionDiv").addClass("col-xs-8");
        }

        // Models 

        function ActionItemModel(item) {
            try {
                var self = this;
                self.IS_SELECTED = ko.observable(false);
                self.AIM_TITLE = ko.observable(item.AIM_TITLE);
                self.AIM_GENERIC_ID = ko.observable(item.AIM_GENERIC_ID);
                self.CLIENT_DE_UID = ko.observable(item.CLIENT_DE_UID);
                self.CLIENT_NAME = ko.observable(item.CLIENT_NAME);
                self.ORG_EBL_UID = ko.observable(item.ORG_EBL_UID);
                self.ORG_NAME = ko.observable(item.ORG_NAME);
                self.SUBORG_DE_UID = ko.observable(item.SUBORG_DE_UID);
                self.SUBORG_NAME = ko.observable(item.SUBORG_NAME);
                self.BU_DE_UID = ko.observable(item.BU_DE_UID);
                self.BU_NAME = ko.observable(item.BU_NAME);
                self.ASSESSMENT_PROFILE_APD_UID = ko.observable(item.ASSESSMENT_PROFILE_APD_UID);
                self.ASSESSMENT_PROFILE = ko.observable(item.ASSESSMENT_PROFILE);
                self.ASSESSMENT_TYPE_RAT_UID = ko.observable(item.ASSESSMENT_TYPE_RAT_UID);
                self.RAT_ASSESSMENT_TYPE = ko.observable(item.RAT_ASSESSMENT_TYPE);
                self.CONTROL_AREA_ECA_UID = ko.observable(item.CONTROL_AREA_ECA_UID);
                self.CONTROL_AREA_NAME = ko.observable(item.CONTROL_AREA_NAME);
                self.QUESTION_ECQ_UID = ko.observable(item.QUESTION_ECQ_UID);
                self.QUESTION_TEXT = ko.observable(item.QUESTION_TEXT);
                self.RESPONSE_TYPE = ko.observable(item.RESPONSE_TYPE);
                self.RESPONSE_UID = ko.observable(item.RESPONSE_UID);
                self.RESPONSE_VALUE = ko.observable(item.RESPONSE_VALUE);
                self.AIM_UID = ko.observable(item.AIM_UID);
                self.AIM_STANDALONE_FLAG = ko.observable(item.AIM_STANDALONE_FLAG);
                self.ActionPlanList = ko.observable(item.ActionPlanList);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ActionItemModel() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
            }
        }

        function ActionItem(item) {
            try {
                var self = this;
                self.IS_SELECTED = item.IS_SELECTED();
                self.AIM_GENERIC_ID = item.AIM_GENERIC_ID();
                self.AIM_TITLE = item.AIM_TITLE();
                self.CLIENT_DE_UID = item.CLIENT_DE_UID();
                self.CLIENT_NAME = item.CLIENT_NAME();
                self.ORG_EBL_UID = item.ORG_EBL_UID();
                self.ORG_NAME = item.ORG_NAME();
                self.SUBORG_DE_UID = item.SUBORG_DE_UID();
                self.SUBORG_NAME = item.SUBORG_NAME();
                self.BU_DE_UID = item.BU_DE_UID();
                self.BU_NAME = item.BU_NAME();
                self.ASSESSMENT_PROFILE_APD_UID = item.ASSESSMENT_PROFILE_APD_UID();
                self.ASSESSMENT_PROFILE = item.ASSESSMENT_PROFILE();
                self.ASSESSMENT_TYPE_RAT_UID = item.ASSESSMENT_TYPE_RAT_UID();
                self.RAT_ASSESSMENT_TYPE = item.RAT_ASSESSMENT_TYPE();
                self.CONTROL_AREA_ECA_UID = item.CONTROL_AREA_ECA_UID();
                self.CONTROL_AREA_NAME = item.CONTROL_AREA_NAME();
                self.QUESTION_ECQ_UID = item.QUESTION_ECQ_UID();
                self.QUESTION_TEXT = item.QUESTION_TEXT();
                self.RESPONSE_TYPE = item.RESPONSE_TYPE();
                self.RESPONSE_UID = item.RESPONSE_UID();
                self.RESPONSE_VALUE = item.RESPONSE_VALUE();
                self.AIM_UID = item.AIM_UID();
                self.AIM_STANDALONE_FLAG = item.AIM_STANDALONE_FLAG();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ActionItemModel() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
            }
        }

        function AssessmentPeriodModel(item) {
            try {
                var self = this;
                self.ASSESSMENT_PERIOD_ID = ko.observable(item.ProfileId);
                self.ASSESSMENT_NAME = ko.observable(item.ProfileName);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: AssessmentPeriodModel() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
            }
        }

        function AssessmentTypeModel(item) {
            try {
                var self = this;
                self.ASSESSMENT_TYPE_ID = ko.observable(item.AssessmentId);
                self.ASSESSMENT_TYPE = ko.observable(item.AssessmentType);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: AssessmentTypeModel() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
            }
        }

        function OrgLevelModel(item) {
            try {
                var self = this;
                self.ORG_LEVEL_ID = ko.observable(item.OrgLevelId);
                self.ORG_LEVEL = ko.observable(item.OrgLevelname);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: OrgLevelModel() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
            }
        }

        function SubOrgLevelModel(item) {
            try {
                var self = this;
                self.SUBORG_LEVEL_ID = ko.observable(item.SubOrgLevelId);
                self.SUBORG_LEVEL = ko.observable(item.SubOrgLevelName);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SubOrgLevelModel() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
            }
        }

        function BUModel(item) {
            try {
                var self = this;
                self.BUSINESS_UNIT_ID = ko.observable(item.BuId);
                self.BUSINESS_UNIT = ko.observable(item.BuName);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BUModel() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
            }
        }

        function ControlAreaModel(item) {
            try {
                var self = this;
                self.CONTROL_AREA_ID = ko.observable(item.ControlAreaId);
                self.CONTROL_AREA = ko.observable(item.ControlAreaName);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ControlAreaModel() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
            }
        }

        function ResponseModel(item) {
            try {
                var self = this;
               // self.RESPONSE_ID = ko.observable(item.ResponseId);
                self.RESPONSE = ko.observable(item.ResponseValue);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ResponseModel() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
            }
        }

        function PlanModel(item) {
            try {
                var self = this;
                self.ActionPlanId = ko.observable(item.ActionPlanId);
                self.ActionPlanLabel = ko.observable(item.ActionPlanLabel);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ResponseModel() method in ConfigureActionTracker.js';
                logger.logMessage(msg);
            }
        }

        function ResponseMoveModel(item) {
            try {
                var self = this;
                self.ActionItemId = ko.observable(item.ActionItemId);
                self.ActionItemNumber = ko.observable(item.ActionItemNumber);
                self.RoleName = ko.observable(item.RoleName);
                self.RoleId = ko.observable(item.RoleId);
                self.ActionItemStatus = ko.observable(item.ActionItemStatus);
                self.CompletedFlag = ko.observable(item.CompletedFlag);
                self.IsComposeFlag = ko.observable(1);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source: ResponseMoveModel() in ActionItemDash.js';
                logger.logMessage(msg);
            }
        }

        //models starts here
        function DropDownListModel(item) {
            try {
                var self = this;
                self.BuId = item.BuId;
                self.BuName = item.BuName;
                self.OrgLevelId = item.OrgLevelId;
                self.OrgLevelname = item.OrgLevelname;
                self.SubOrgLevelName = item.SubOrgLevelName;
                self.SubOrgLevelId = item.SubOrgLevelId;

            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source: DropDownListModel() in ActionItemDash.js';
                logger.logMessage(msg);
            }
        }

        function AssessmentProfileMode(item) {
            try {
                var self = this;
                self.Profilename = item.Profilename;
                self.ProfileId = item.ProfileId;
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source: AssessmentProfileMode() in ActionItemDash.js';
                logger.logMessage(msg);
            }
        }
        //models ends here

        function BackToAPMDetails() {
            try {
                //vm.ResponseMoveArrayItem(new ResponseMoveModel({ ActionPlanId: vm.ActionPlanId() }));
                router.navigate("#ActionTracker/ActionPlanDetails", true);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | BackToAPMDetails() in ActionItemDash.js';
                logger.logMessage(msg);
            }
        };

    });
